/**
 * Pause / resume / archive / restore for a habit (Habits UX pass 2026-09-06).
 * Pause, resume and archive are Auto-Mom's routes on the execution
 * definition (they repaint future occurrences and record the audit trail);
 * restore is the hierarchy route that un-archives and refills the schedule.
 */
async function post(url: string, body?: Record<string, unknown>): Promise<Record<string, unknown>> {
  const r = await fetch(url, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) })
  const data = await r.json().catch(() => ({}))
  if (!r.ok || data.success === false) throw new Error((data.error as string) || 'That did not go through')
  return data
}

export type PausePreset = 'week' | 'two_weeks' | 'month' | 'open'

export function pauseUntilFor(preset: PausePreset): string | null {
  if (preset === 'open') return null
  const days = preset === 'week' ? 7 : preset === 'two_weeks' ? 14 : 30
  const d = new Date()
  d.setDate(d.getDate() + days)
  d.setHours(8, 0, 0, 0)
  return d.toISOString()
}

export const habitLifecycle = {
  pause: (definitionId: number, preset: PausePreset) =>
    post(`/api/automom/habits/${definitionId}/pause`, { paused_until: pauseUntilFor(preset), reason_codes: ['user_choice'], source: 'habit_page' }),
  resume: (definitionId: number) => post(`/api/automom/habits/${definitionId}/restart`),
  archive: (definitionId: number, reason?: string) =>
    post(`/api/automom/habits/${definitionId}/archive`, { source: 'habit_page', reason: reason || undefined }),
  restore: (habitId: number | string) => post(`/api/hierarchy/habits/${habitId}/restore`),
}
